import { Type } from '@sinclair/typebox';
export const FilterCollectionResponseSchema = Type.Object({
    id: Type.Number(),
    versionId: Type.Number(),
    name: Type.String(),
});
export const CreateFilterCollectionSchema = Type.Omit(FilterCollectionResponseSchema, ['id']);
export const UpdateFilterCollectionSchema = Type.Partial(Type.Omit(CreateFilterCollectionSchema, ['versionId']));
//# sourceMappingURL=filter-collections.js.map